import React from "react";
import { useTranslation } from "react-i18next";
import VipStatus from "components/user/VipStatus";
import multiMode from "./filterBaseMulti";
import singleMode from "./filterBaseSingle";

const rawItems = [
	{
		key: "gallery",
		value: "gallery",
		meta: {
			url: "with_gallery",
			api: 1,
		},
	},
	{
		key: "online",
		value: "online",
		meta: {
			url: "online",
			api: 8,
		},
	},
	{
		key: "meet",
		value: "meet",
		meta: {
			url: "meet",
			api: 64,
		},
	},
	{
		key: "verified",
		value: "verified",
		meta: {
			url: "verified",
			api: 4,
			icon: 2,
		},
	},
	{
		key: "vip",
		value: "vip",
		meta: {
			url: "vip",
			api: 16,
			icon: 3,
		},
	},
	{
		key: "superVip",
		value: "super_vip",
		meta: {
			url: "super_vip",
			api: 32,
			icon: 5,
		},
	},
];

export const isValid = (value) => {
	if (value === "") {
		return true;
	}
	const validValuesArray = rawItems.map((item) => item.meta.url);
	const incomingValuesArray = value ? value.split(/[,/-]/) : [];

	for (let i = 0; i < incomingValuesArray.length; i++) {
		if (!validValuesArray.includes(incomingValuesArray[i])) {
			return false;
		}
	}

	return true;
};

export const compute = (multiple) =>
	multiple
		? {
				urlToApiParam: (value) => {
					if (!value) return null;
					const current = value
						.split(/[,/-]/)
						.map((item) => {
							const itemIndex = rawItems.findIndex(
								(rawItem) => rawItem?.meta?.url === item
							);
							if (itemIndex !== -1) {
								return rawItems[itemIndex];
							}
						})
						.reduce(
							(acc, currentValue) =>
								acc + (currentValue?.meta?.api || 0),
							0
						);
					return current;
				},
				urlToKeysArray: (value) => {
					if (!value) return null;
					const incomingValuesArray = value
						? value.split(/[,/-]/)
						: [];
					return incomingValuesArray.map((incomingValue) => {
						return rawItems.find(
							(rawItem) => rawItem?.meta?.url === incomingValue
						).key;
					});
				},
				valueToUrl: (values) => {
					const current = values
						? rawItems.filter((item) => values.includes(item.value))
						: [];
					return current.length
						? current.map((item) => item.meta.url).join("-")
						: "";
				},
		  }
		: {
				valueToApiParam: (value) => {
					const current = rawItems.find(
						(item) => item.meta.url === value
					);
					return current ? current.value : null;
				},
				urlToApiParam: (value) => {
					const current = rawItems.find(
						(item) => item.value === value
					);
					return current ? current.value : null;
				},
				valueToUrl: (value) => {
					const current = rawItems.find(
						(item) => item.value === value
					);
					return current ? current.meta.url : "";
				},
		  };

export { rawItems };

const useFilterContent = ({ initial, multiple, allItems }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);
	const items = (
		allItems ? rawItems.filter(({ meta: { all } }) => !all) : rawItems
	).map((item) => ({
		...item,
		content: (
			<>
				{t(`filtersAndSelectors:only.${item.key}`)}
				{item.meta?.icon && (
					<>
						{" "}
						<VipStatus status={item.meta.icon} height={14} noPad />
					</>
				)}
			</>
		),
	}));

	return {
		rawItems,
		items,
		compute: compute(multiple),
		isMultiple: multiple,
		isValid,
		...(multiple
			? multiMode({ items, initial, compute })
			: singleMode({ items, initial, compute })),
	};
};

export default useFilterContent;
